import balance from './balance'
import feralCombat from './feral-combat'
import restoration from './restoration'

const druid = { specs: [balance, feralCombat, restoration] }

export default druid
